import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  padding: 40px 0 30px 0;
  text-align: center;
`;

const ContentWrapperOnMobile = media.phone`
  padding: 40px 0;
`;

export const ContentWrapper = styled.div`
  padding: 50px 0;
  ${ContentWrapperOnMobile};
`;

const Wrapper = styled.section`
  position: relative;
  overflow: hidden;
`;

export const HostingPlayerContainer = styled.div`
  pointer-events: none;
`;

export default Wrapper;
